import BreakPoints from '../../styles/breakpoints';
import findKey from 'lodash/findKey';

export default class MediaQueries {
	constructor(screensize) {
		this.screensize = screensize;
	}

	getViewportHeight() {
		return this.showFullView() ? 'calc(100vh - 75px)' : 'calc(100vh - 64px)';
	}

	getCurrentDeviceSize() {
		return this.screensize;
	}

	getCurrentBreakPointName() {
		return findKey(BreakPoints, breakPoint => this.screensize === breakPoint);
	}

	isExtraSmallDevice = () => {
		return (this.screensize === BreakPoints.XS);
	};

	isSmallDevice = () => {
		return (this.screensize === BreakPoints.S);
	};

	isMediumDevice = () => {
		return (this.screensize === BreakPoints.M);
	};

	isLargeDevice = () => {
		return (this.screensize === BreakPoints.L);
	};

	isExtraLargeDevice = () => {
		return (this.screensize === BreakPoints.XL);
	};

	isMinExtraSmallDevice = () => {
		return (this.screensize >= BreakPoints.XS);
	};

	isMinSmallDevice = () => {
		return (this.screensize >= BreakPoints.S);
	};

	isMinMediumDevice = () => {
		return (this.screensize >= BreakPoints.M);
	};

	isMinLargeDevice = () => {
		return (this.screensize >= BreakPoints.L);
	};

	isMinExtraLargeDevice = () => {
		return (this.screensize >= BreakPoints.XL);
	};

	isMaxExtraSmallDevice = () => {
		return (this.screensize <= BreakPoints.XS);
	};

	isMaxSmallDevice = () => {
		return (this.screensize <= BreakPoints.S);
	};

	isMaxMediumDevice = () => {
		return (this.screensize <= BreakPoints.M);
	};

	isMaxLargeDevice = () => {
		return (this.screensize <= BreakPoints.L);
	};

	isMaxExtraLargeDevice = () => {
		return (this.screensize <= BreakPoints.XL);
	};

	showFullView = () => {
		return this.isMinLargeDevice();
	};

	isMediumOrExtraLargeDevice = () => {
		return this.isMinExtraLargeDevice() || this.isMediumDevice();
	};
}



// WEBPACK FOOTER //
// ./src/utils/style/mediaQueries.js